import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store ,persistor} from "./redux/store";
import { Provider } from "react-redux";
import { ErrorFallback } from "./utils/ErrorBoundary";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorBoundary } from "react-error-boundary";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        localStorage.clear();
        sessionStorage.clear();
        // window.location.href = "/";
        window.location.reload();
      }}
    >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

